import React from "react";
import "./loader.css";
import LogoLoad from "../../images/logo/logo-loader.svg";
export default function FLoader() {
	return (
		<div className="loading-page">
			<div className="loader"></div>
			<img className="load-img" src={LogoLoad} alt="Loading" />
		</div>
	);
}
